// @flow
import React, { useContext, useState } from 'react';
import Sticky from 'react-stickynode';

import { CriteriaContextProvider } from 'Components/widgets/criteria/CriteriaContext';
import { CriteriaDisplayProvider } from 'Components/widgets/criteria/CriteriaDisplayContext';
import { PriceRemote } from 'Components/widgets/price-remote/PriceRemote';
import ReactAppContext from 'Context/ReactAppContext';
import {
  PriceRemoteContext,
  PriceRemoteContextProvider,
} from 'Components/widgets/price-remote/PriceRemoteContext';
import { isFeatureFlipped } from 'Utils/feature-flipping/featureFlippingUtils';
import { PRICE_REMOTE_STICKY_WRAPPER_CLASSNAME } from 'Components/widgets/price-remote/constants';
import { t } from 'Src/i18n';

export type Props = {|
  product: Resort,
  bookingCriteria: BookingCriteria,
  urgentisationRate: number,
|};

export const PriceRemoteStickyWrapper = ({
  bookingCriteria,
  product,
  urgentisationRate,
}: Props) => {
  const [isSticky, setIsSticky] = useState(false);
  const appContext = useContext(ReactAppContext);
  const bottomBoundary = '.PriceTicket-sticky-beacon';

  const onStateChange = (status: *) => {
    setIsSticky(status.status !== Sticky.STATUS_ORIGINAL);
  };

  const isPriceRemoteEnabled = isFeatureFlipped(appContext)('priceRemote.enabled');
  if (!isPriceRemoteEnabled) {
    return null;
  }

  return (
    <PriceRemoteContextProvider>
      <CriteriaContextProvider
        value={{
          trackingActionName: 'priceBar',
          layerButtonLabel: t('booking.editCriteria.validateCriteria'),
        }}
      >
        <div className={isSticky ? 'PriceRemoteStickyWrapper--isSticky' : null}>
          <div className={`${PRICE_REMOTE_STICKY_WRAPPER_CLASSNAME} -mt-2 pb-2`} />
          <PriceRemoteContext.Consumer>
            {([{ isOverrideSticky, isDetailOpened }]) => (
              <Sticky
                activeClass="sticky-bottom"
                releasedClass="sticky-bottom-released"
                onStateChange={onStateChange}
                bottomBoundary={bottomBoundary}
                enabled={isOverrideSticky}
                innerZ={isOverrideSticky && !isDetailOpened ? 2 : 6}
              >
                <CriteriaDisplayProvider>
                  <PriceRemote
                    bookingCriteria={bookingCriteria}
                    isSticky={isSticky}
                    product={product}
                    urgentisationRate={urgentisationRate}
                  />
                </CriteriaDisplayProvider>
              </Sticky>
            )}
          </PriceRemoteContext.Consumer>
        </div>
      </CriteriaContextProvider>
    </PriceRemoteContextProvider>
  );
};
